
    import * as React from 'react';

    const Home20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Home_20_svg__Icons/Home/20" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M2,18 L2,7.2532833 L10,2 L18,7.2532833 L18,18 L13,18 L7,18 L2,18 Z M10,3.25 L3,7.844 L3,17 L7,17 L7,11 L7.00509269,10.8237272 C7.09633912,9.24891996 8.40231912,8 10,8 C11.6568542,8 13,9.34314575 13,11 L13,17 L17,17 L17,7.844 L10,3.25 Z M10,9 C8.93934251,9 8.06443602,9.82847683 8.00467561,10.8526061 L8,11 L8,17 L12,17 L12,11 C12,9.8954305 11.1045695,9 10,9 Z" id="Home_20_svg__Combined-Shape-Copy-2" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Home20.displayName = 'Home20';

    export default Home20;
  